import React, { useState } from "react";
import getStyles from "../tool/Style";
import { Typography, TextField, Button, Grid, Box } from "@mui/material";
import HowToRegIcon from '@mui/icons-material/HowToReg';

import { loginUsuario } from "../../actions/UsuarioAction";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../contexto/store";

import { LogoIcon } from "../Tool";
import Notice from "../../componentes/notice/Notice";
import { useTheme } from "@mui/material/styles";
import { sboPrint } from "../../utils/sboPrintClient";

const Login = () => {
  const theme = useTheme();
  const [{ usuarioSesion, institution }, dispatch] = useStateValue();
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState({
    Email: "",
    Password: "",
  });

  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setUsuario((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };

  const loginUsuarioBoton = (e) => {
    e.preventDefault();
    loginUsuario(usuario, dispatch).then((response) => {
      if (response && response.status === 200) {
        window.localStorage.setItem("token_seguridad", response.data.token);
        sboPrint.isInstalled().then((installed) => {
          if (installed) sboPrint.ensurePaired().catch(() => {});
        });
        navigate("/dashboard");
      } else {
        const backendMsg = response?.data?.errors?.message;
        const fallbackMsg = response?.status === 429
          ? "Demasiados intentos. Por favor, intente de nuevo más tarde."
          : "Las credenciales del usuario son incorrectas o el servicio no está disponible.";
        dispatch({
          type: "OPEN_SNACKBAR",
          openMensaje: {
            open: true,
            mensaje: backendMsg || fallbackMsg,
          },
        });
      }
    });
  };

  const clases = getStyles(theme);

  return (
    <Box
      component="main"
      sx={{
        background: 'linear-gradient(135deg, #F5F7FA 0%, #E0F2F1 100%)',
        display: 'flex',
        justifyContent: 'center',
        minHeight: '100vh',
        alignItems: 'center',
        p: 2,
        overflowY: 'auto'
      }}
    >
      <Box sx={{
        ...clases.paperUno,
        maxWidth: 1000,
        bgcolor: 'background.paper',
        borderRadius: 4,
        overflow: 'hidden',
        boxShadow: '0px 20px 40px rgba(0,0,0,0.1)'
      }}>
        <Grid container sx={{ minHeight: 600 }}>
          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: 'background.default'
            }}
          >
            <Box sx={{ mb: 2, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {institution?.logo ? (
                <Box
                  component="img"
                  src={institution.logo}
                  alt="Logo"
                  sx={{
                    width: 'auto',
                    maxWidth: '100%',
                    height: 'auto',
                    maxHeight: { xs: '80px', md: '120px' },
                    objectFit: 'contain',
                    mb: 2
                  }}
                />
              ) : (
                <LogoIcon color="primary" sx={{ fontSize: '4rem' }} />
              )}
              <Typography variant="h5" sx={{ fontWeight: 800, mt: 1 }}>
                {institution?.name || "AGUA POTABLE"}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {institution?.about || "Sistema de Gestión de Agua Potable"}
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }} sx={clases.fondoLogin} >

            <Typography component="h1" variant="h4" sx={{ fontWeight: 700, mb: 4, letterSpacing: 1 }}>
              BIENVENIDO
            </Typography>
            <Box component="form" onSubmit={loginUsuarioBoton} sx={{ width: '100%', px: 2 }}>
              <Grid container spacing={2}>
                <Grid size={12}>
                  <TextField
                    name="Email"
                    value={usuario.Email}
                    onChange={ingresarValoresMemoria}
                    variant="filled"
                    label="Correo Electrónico"
                    fullWidth slotProps={{ input: { disableUnderline: true, sx: { borderRadius: 2, bgcolor: 'rgba(255,255,255,0.15)', color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' } } }, inputLabel: { sx: { color: 'rgba(255,255,255,0.7)' } } }}
                  />
                </Grid>
                <Grid size={12}>
                  <TextField
                    name="Password"
                    value={usuario.Password}
                    onChange={ingresarValoresMemoria}
                    variant="filled"
                    type="password"
                    label="Contraseña"
                    fullWidth slotProps={{ input: { disableUnderline: true, sx: { borderRadius: 2, bgcolor: 'rgba(255,255,255,0.15)', color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' } } }, inputLabel: { sx: { color: 'rgba(255,255,255,0.7)' } } }}
                  />
                </Grid>
              </Grid>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                sx={{
                  mt: 4,
                  bgcolor: 'white',
                  color: 'primary.main',
                  fontWeight: 'bold',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' }
                }}
              >
                INGRESAR
              </Button>
              <Button
                onClick={() => navigate("/")}
                fullWidth
                variant="text"
                sx={{
                  mt: 2,
                  color: 'rgba(255, 255, 255, 0.8)',
                  fontWeight: 'bold',
                  textTransform: 'none',
                  '&:hover': { color: 'white', bgcolor: 'rgba(255,255,255,0.1)' }
                }}
              >
                Volver a la página principal
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Login;
